module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "picker"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "picker-wrapper"
  }, [_c('div', {
    staticClass: "picker-container"
  }, [_c('div', {
    staticClass: "picker-header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "picker-body",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "border-bottom-1px"
  }), _vm._v(" "), _c('i', {
    staticClass: "border-top-1px"
  }), _vm._v(" "), _c('div', {
    ref: "pickerWheel",
    staticClass: "picker-wheel"
  }, [_c('ul', {
    staticClass: "wheel-scroll"
  }, _vm._l((_vm.dataItems), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "wheel-item"
    }, [_vm._v(_vm._s(item.label))])
  }))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b4ff446","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Picker.vue
// module id = 241
// module chunks = 1